(function () {
  if (window.UFInstallationVideosLoaded) {
    if (typeof window.UFInitInstallationVideos === "function") {
      window.UFInitInstallationVideos(document);
    }
    return;
  }

  window.UFInstallationVideosLoaded = true;

  function getYouTubeId(input) {
    if (!input) return "";

    var value = input.trim();

    if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
      return value;
    }

    try {
      var url = new URL(value);
      var host = url.hostname.replace("www.", "").replace("m.", "");

      if (host === "youtu.be") {
        return url.pathname.split("/").filter(Boolean)[0] || "";
      }

      if (host.indexOf("youtube.com") !== -1) {
        var watchId = url.searchParams.get("v");

        if (watchId) {
          return watchId;
        }

        var parts = url.pathname.split("/").filter(Boolean);

        var typeIndex = parts.findIndex(function (part) {
          return part === "embed" || part === "shorts" || part === "live";
        });

        if (typeIndex > -1 && parts[typeIndex + 1]) {
          return parts[typeIndex + 1];
        }
      }
    } catch (error) {
      return "";
    }

    return "";
  }

  function parseVideoLine(line, index) {
    if (!line) return null;

    var parts = line.split("|");
    var title = "";
    var url = "";

    if (parts.length > 1) {
      title = parts[0].trim();
      url = parts.slice(1).join("|").trim();
    } else {
      url = line.trim();
      title = "Installation Video " + String(index + 1).padStart(2, "0");
    }

    var id = getYouTubeId(url);

    if (!id) return null;

    return {
      id: id,
      title: title || "Installation Video " + String(index + 1).padStart(2, "0")
    };
  }

  function createVideoCard(video, onClick) {
    var card = document.createElement("button");
    card.type = "button";
    card.className = "uf-install-video-card";
    card.setAttribute("aria-label", "Play " + video.title);
    card.dataset.videoId = video.id;

    var thumb = document.createElement("span");
    thumb.className = "uf-install-video-card__thumb";

    var image = document.createElement("img");
    image.src = "https://i.ytimg.com/vi/" + video.id + "/hqdefault.jpg";
    image.alt = video.title;
    image.loading = "lazy";

    var play = document.createElement("span");
    play.className = "uf-install-video-card__play";
    play.setAttribute("aria-hidden", "true");

    var title = document.createElement("span");
    title.className = "uf-install-video-card__title";
    title.textContent = video.title;

    thumb.appendChild(image);
    thumb.appendChild(play);

    card.appendChild(thumb);
    card.appendChild(title);

    card.addEventListener("click", function () {
      onClick(video.id);
    });

    return card;
  }

  function updateArrowState(track, prev, next) {
    if (!track) return;

    var maxScrollLeft = track.scrollWidth - track.clientWidth;
    var currentScrollLeft = track.scrollLeft;

    if (prev) {
      prev.disabled = currentScrollLeft <= 2;
    }

    if (next) {
      next.disabled = currentScrollLeft >= maxScrollLeft - 2;
    }
  }

  function initUFVideoModule(module) {
    if (!module || module.dataset.ufVideoInitialized === "true") return;

    var rawNode = module.querySelector("[data-uf-video-urls]");
    var track = module.querySelector("[data-uf-video-track]");
    var prev = module.querySelector("[data-uf-video-prev]");
    var next = module.querySelector("[data-uf-video-next]");
    var modal = module.querySelector("[data-uf-video-modal]");
    var iframe = module.querySelector("[data-uf-video-iframe]");
    var closeButtons = module.querySelectorAll("[data-uf-video-close]");

    if (!rawNode || !track || !modal || !iframe) return;

    var raw = "";

    try {
      raw = JSON.parse(rawNode.textContent || '""');
    } catch (error) {
      raw = rawNode.textContent || "";
    }

    var videos = raw
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .map(parseVideoLine)
      .filter(Boolean);

    if (!videos.length) {
      module.style.display = "none";
      return;
    }

    function openModal(videoId) {
      iframe.src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0";
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("uf-video-modal-open");
    }

    function closeModal() {
      iframe.src = "";
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("uf-video-modal-open");
    }

    videos.forEach(function (video) {
      var card = createVideoCard(video, openModal);
      track.appendChild(card);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    if (prev) {
      prev.addEventListener("click", function () {
        track.scrollBy({
          left: -track.clientWidth,
          behavior: "smooth"
        });
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        track.scrollBy({
          left: track.clientWidth,
          behavior: "smooth"
        });
      });
    }

    track.addEventListener(
      "wheel",
      function (event) {
        var maxScrollLeft = track.scrollWidth - track.clientWidth;

        if (maxScrollLeft <= 0) return;

        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        var before = track.scrollLeft;
        track.scrollLeft += event.deltaY;
        var after = track.scrollLeft;

        if (before !== after) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    track.addEventListener("scroll", function () {
      updateArrowState(track, prev, next);
    });

    window.addEventListener("resize", function () {
      updateArrowState(track, prev, next);
    });

    updateArrowState(track, prev, next);

    module.dataset.ufVideoInitialized = "true";
  }

  function initAllUFVideoModules(root) {
    var scope = root || document;

    scope.querySelectorAll("[data-uf-video-module]").forEach(function (module) {
      initUFVideoModule(module);
    });
  }

  window.UFInitInstallationVideos = initAllUFVideoModules;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllUFVideoModules(document);
    });
  } else {
    initAllUFVideoModules(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllUFVideoModules(event.target);
  });
})();